document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("quickbuy-modal");
  if (!modal) return;

  // Ensure modal is hidden on page load
  modal.classList.add("hidden");
  modal.classList.remove("active");

  // Create Size Chart Modal (if not present)
  createSizeChartModal();

  const overlay = modal.querySelector(".quickbuy-overlay");
  const closeBtn = modal.querySelector(".qb-close");
  const loader = modal.querySelector(".qb-loader");
  const content = modal.querySelector(".quickbuy-content");
  const form = modal.querySelector(".quickbuy-form");

  let currentProduct = null;
  let selectedVariant = null;
  let sizeChartData = null;
  let quickBuySource = null; // Track which section triggered Quick Buy: 'worn-together' or 'you-may-also-like'

  // ---------- Open Quick Buy Modal ----------
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest
      ? e.target.closest("[data-quickbuy-url]")
      : null;
    if (!btn) return;

    e.preventDefault();
    const url = btn.getAttribute("data-quickbuy-url");
    if (!url) return;

    // Reset add-to-cart button state
    const addToCartBtn = form?.querySelector(".quickbuy-add-to-cart");
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Add to Cart";
    }

    // Show modal + loader
    if (loader) loader.style.display = "block";
    if (content) content.style.display = "none";
    modal.classList.add("active");
    modal.classList.remove("hidden");

    // Detect which section triggered the Quick Buy
    const isWornTogether = btn.closest(
      ".worn-together-block, .worn-together-block__product-card, .worn-together-product-card, .worn-together-wrapper, .section-worn-together, [data-worn-together-block]"
    );
    const isYouMayAlsoLike = btn.closest(
      "product-block, .product-block, .you-may-also-like, [class*='product-recommendations'], [class*='recommendations']"
    );

    // Remove previous source classes
    modal.classList.remove("qb-worn-together", "qb-you-may-also-like");

    if (isWornTogether) {
      quickBuySource = "worn-together";
      modal.classList.add("qb-worn-together");
      console.log("[QuickBuy] Source detected: Worn Together section");
    } else if (isYouMayAlsoLike) {
      quickBuySource = "you-may-also-like";
      modal.classList.add("qb-you-may-also-like");
      console.log("[QuickBuy] Source detected: You May Also Like section");
    } else {
      // Default to you-may-also-like if can't determine
      quickBuySource = "you-may-also-like";
      modal.classList.add("qb-you-may-also-like");
      console.log(
        "[QuickBuy] Source not detected, defaulting to: You May Also Like"
      );
    }

    // Try to extract rating from product card containing the quick buy button
    let extractedRating = null;
    const productCard = btn.closest
      ? btn.closest(
        ".worn-together-block__product-card, .worn-together-product-card, .product-block"
      )
      : null;

    if (productCard) {
      // PRIORITY 1: Judge.me badge
      const judgeMeBadge = productCard.querySelector(
        ".jdgm-widget, .jdgm-preview-badge"
      );
      if (judgeMeBadge) {
        // Try data-score attribute
        const scoreAttr = judgeMeBadge.getAttribute("data-score");
        if (scoreAttr) {
          const rating = parseFloat(scoreAttr);
          if (!isNaN(rating) && rating > 0 && rating <= 5) {
            extractedRating = rating;
          }
        }

        // Try from badge text content
        if (!extractedRating) {
          const badgeText =
            judgeMeBadge.textContent || judgeMeBadge.innerText || "";
          const match = badgeText.match(
            /(\d+\.?\d*)\s*(?:stars?|out of|rating)/i
          );
          if (match) {
            const rating = parseFloat(match[1]);
            if (!isNaN(rating) && rating > 0 && rating <= 5) {
              extractedRating = rating;
            }
          }
        }

        // Try from aria-label
        if (!extractedRating) {
          const ariaLabel = judgeMeBadge.getAttribute("aria-label");
          if (ariaLabel) {
            const match = ariaLabel.match(
              /(\d+\.?\d*)\s*(?:stars?|out of|rating)/i
            );
            if (match) {
              const rating = parseFloat(match[1]);
              if (!isNaN(rating) && rating > 0 && rating <= 5) {
                extractedRating = rating;
              }
            }
          }
        }

        // Try from nested elements
        if (!extractedRating) {
          const ratingElement = judgeMeBadge.querySelector(
            ".jdgm-prev-badge__stars, [data-score], .jdgm-prev-badge__text"
          );
          if (ratingElement) {
            const score =
              ratingElement.getAttribute("data-score") ||
              ratingElement.getAttribute("aria-label") ||
              ratingElement.textContent;
            if (score) {
              const match = score.toString().match(/(\d+\.?\d*)/);
              if (match) {
                const rating = parseFloat(match[1]);
                if (!isNaN(rating) && rating > 0 && rating <= 5) {
                  extractedRating = rating;
                }
              }
            }
          }
        }
      }

      // PRIORITY 2: rating text like "4.2 / 5"
      if (!extractedRating) {
        const ratingText = productCard.querySelector(".cc-rating-text");
        if (ratingText) {
          const text = ratingText.textContent || ratingText.innerText || "";
          const match = text.match(/(\d+\.?\d*)\s*\/\s*\d+/);
          if (match) {
            const rating = parseFloat(match[1]);
            if (!isNaN(rating) && rating > 0 && rating <= 5) {
              extractedRating = rating;
            }
          }
        }
      }

      // PRIORITY 3: aria-label or star count
      if (!extractedRating) {
        const ratingElement = productCard.querySelector(
          "[data-rating-decimal], .cc-rating[data-rating-decimal]"
        );
        if (ratingElement) {
          const ariaLabel = ratingElement.getAttribute("aria-label");
          if (ariaLabel) {
            const match = ariaLabel.match(/(\d+\.?\d*)\s*(?:out of|stars)/i);
            if (match) {
              const rating = parseFloat(match[1]);
              if (!isNaN(rating) && rating > 0 && rating <= 5) {
                extractedRating = rating;
              }
            }
          }

          // Fallback: count active stars
          if (!extractedRating) {
            const activeStars = ratingElement.querySelectorAll(
              ".cc-rating-stars--active .cc-rating-stars__svg"
            );
            const decimalAttr = ratingElement.getAttribute(
              "data-rating-decimal"
            );
            if (activeStars.length > 0) {
              let rating = activeStars.length;
              if (decimalAttr === "0.5") rating -= 0.5;
              if (rating > 0 && rating <= 5) extractedRating = rating;
            }
          }
        }
      }
    }

    try {
      // Try rating from current page product JSON if same product
      const currentPageProductJson = document.querySelector(
        'script[type="application/json"][id^="ProductJson-"]'
      );
      if (currentPageProductJson) {
        try {
          const currentPageProduct = JSON.parse(
            currentPageProductJson.textContent
          );
          const currentUrl = new URL(window.location.href);
          const targetUrl = new URL(url, window.location.origin);
          if (currentUrl.pathname === targetUrl.pathname) {
            extractRatingFromPage(document, currentPageProduct);
            if (currentPageProduct._extractedRating) {
              extractedRating = currentPageProduct._extractedRating;
            }
          }
        } catch (e) {
          // ignore
        }
      }

      // Fetch product page
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Store product URL for accessory detection & view-details building
      const productUrl = url;

      // Extract product JSON
      const productJsonScript = doc.querySelector(
        'script[type="application/json"][id^="ProductJson-"]'
      );
      if (!productJsonScript) throw new Error("Product data not found");

      currentProduct = JSON.parse(productJsonScript.textContent);

      // Validate product data
      if (
        !currentProduct ||
        !currentProduct.variants ||
        currentProduct.variants.length === 0
      ) {
        throw new Error("Invalid product data");
      }

      selectedVariant =
        currentProduct.variants.find((v) => v.available) ||
        currentProduct.variants[0];

      if (!selectedVariant) throw new Error("No available variant found");

      // Extract rating from the fetched page (metafields / JSON-LD / DOM)
      extractRatingFromPage(doc, currentProduct);

      // If extractedRating from product card is present and not already set, use it
      if (extractedRating && !currentProduct._extractedRating) {
        currentProduct._extractedRating = extractedRating;
      }

      // Extract size chart data from fetched doc
      extractSizeChartData(doc, currentProduct, productUrl);

      // Populate size chart modal with extracted data
      populateSizeChartModal();

      // Populate modal
      populateModal(currentProduct, selectedVariant);

      // Hide loader, show content
      if (loader) loader.style.display = "none";
      if (content) content.style.display = "block";
    } catch (error) {
      console.error("Error loading product:", error);
      if (loader) {
        loader.textContent = "Error loading product. Please try again.";
        loader.style.display = "block";
      }
      if (content) content.style.display = "none";
    }
  });

  // ---------- Rating extraction ----------
  function extractRatingFromPage(doc, product) {
    if (!doc || !product) return;

    // Priority 1: Judge.me badge
    const judgeMeBadge = doc.querySelector(".jdgm-widget, .jdgm-preview-badge");
    if (judgeMeBadge) {
      // Try data-score attribute
      const scoreAttr = judgeMeBadge.getAttribute("data-score");
      if (scoreAttr) {
        const rating = parseFloat(scoreAttr);
        if (!isNaN(rating) && rating > 0 && rating <= 5) {
          product._extractedRating = rating;
          return;
        }
      }

      // Try from badge text content
      const badgeText =
        judgeMeBadge.textContent || judgeMeBadge.innerText || "";
      const match = badgeText.match(/(\d+\.?\d*)\s*(?:stars?|out of|rating)/i);
      if (match) {
        const rating = parseFloat(match[1]);
        if (!isNaN(rating) && rating > 0 && rating <= 5) {
          product._extractedRating = rating;
          return;
        }
      }

      // Try from aria-label
      const ariaLabel = judgeMeBadge.getAttribute("aria-label");
      if (ariaLabel) {
        const match = ariaLabel.match(
          /(\d+\.?\d*)\s*(?:stars?|out of|rating)/i
        );
        if (match) {
          const rating = parseFloat(match[1]);
          if (!isNaN(rating) && rating > 0 && rating <= 5) {
            product._extractedRating = rating;
            return;
          }
        }
      }

      // Try from nested elements
      const ratingElement = judgeMeBadge.querySelector(
        ".jdgm-prev-badge__stars, [data-score], .jdgm-prev-badge__text"
      );
      if (ratingElement) {
        const score =
          ratingElement.getAttribute("data-score") ||
          ratingElement.getAttribute("aria-label") ||
          ratingElement.textContent;
        if (score) {
          const match = score.toString().match(/(\d+\.?\d*)/);
          if (match) {
            const rating = parseFloat(match[1]);
            if (!isNaN(rating) && rating > 0 && rating <= 5) {
              product._extractedRating = rating;
              return;
            }
          }
        }
      }
    }

    // Priority 2: cc-rating-text like "4.2 / 5"
    const ratingText = doc.querySelector(".cc-rating-text");
    if (ratingText) {
      const text = ratingText.textContent || ratingText.innerText || "";
      const match = text.match(/(\d+\.?\d*)\s*\/\s*\d+/);
      if (match) {
        const rating = parseFloat(match[1]);
        if (!isNaN(rating) && rating > 0 && rating <= 5) {
          product._extractedRating = rating;
          return;
        }
      }
    }

    // Priority 3: element with data-rating-decimal or aria-label
    const ratingElement = doc.querySelector(
      "[data-rating-decimal], .cc-rating[data-rating-decimal]"
    );
    if (ratingElement) {
      const ariaLabel = ratingElement.getAttribute("aria-label");
      if (ariaLabel) {
        const match = ariaLabel.match(/(\d+\.?\d*)\s*(?:out of|stars)/i);
        if (match) {
          const rating = parseFloat(match[1]);
          if (!isNaN(rating) && rating > 0 && rating <= 5) {
            product._extractedRating = rating;
            return;
          }
        }
      }

      const activeStars = ratingElement.querySelectorAll(
        ".cc-rating-stars--active .cc-rating-stars__svg"
      );
      const decimalAttr = ratingElement.getAttribute("data-rating-decimal");
      if (activeStars.length > 0) {
        let rating = activeStars.length;
        if (decimalAttr === "0.5") rating -= 0.5;
        if (rating > 0 && rating <= 5) {
          product._extractedRating = rating;
          return;
        }
      }
    }

    // Priority 3: structured data (JSON-LD)
    const structuredDataScripts = doc.querySelectorAll(
      'script[type="application/ld+json"]'
    );
    for (const script of structuredDataScripts) {
      try {
        const data = JSON.parse(script.textContent);
        const items = Array.isArray(data) ? data : [data];
        for (const item of items) {
          if (
            item &&
            item["@type"] === "Product" &&
            item.aggregateRating &&
            item.aggregateRating.ratingValue
          ) {
            const rating = parseFloat(item.aggregateRating.ratingValue);
            if (!isNaN(rating) && rating > 0) {
              product._extractedRating = rating;
              return;
            }
          }
        }
      } catch (e) {
        // ignore parse errors
      }
    }

    // Fallback: try metafields (handled later when populating modal)
  }

  // ---------- Populate modal ----------
  function populateModal(product, variant) {
    if (!modal) return;

    // Reset add-to-cart button
    const addToCartBtn = form?.querySelector(".quickbuy-add-to-cart");
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Add to Cart";
    }

    // Title + Price
    const titleEl = modal.querySelector(".quickbuy-title");
    const priceEl = modal.querySelector(".quickbuy-price");
    if (titleEl) titleEl.textContent = product.title || "";
    if (priceEl) priceEl.textContent = formatPrice(variant.price);

    // Rating display
    const ratingEl = modal.querySelector(".quickbuy-rating-badge");
    let ratingValue = null;

    if (product._extractedRating) {
      ratingValue = product._extractedRating;
      console.log("[Quick Buy] Using extracted rating:", ratingValue);
    } else if (product.metafields) {
      console.log("[Quick Buy] Checking product metafields for rating");
      console.log(
        "[Quick Buy] Product metafields available:",
        !!product.metafields
      );
      console.log(
        "[Quick Buy] Metafields keys:",
        product.metafields ? Object.keys(product.metafields) : []
      );

      // Priority 1: Judge.me metafields
      if (product.metafields.judgeme) {
        console.log(
          "[Quick Buy] Reading metafield: product.metafields.judgeme"
        );
        console.log(
          "[Quick Buy] judgeme.rating:",
          product.metafields.judgeme.rating
        );
        console.log(
          "[Quick Buy] judgeme.review_count:",
          product.metafields.judgeme.review_count
        );

        const judgeMeRating = product.metafields.judgeme.rating;
        if (judgeMeRating) {
          if (typeof judgeMeRating === "number") {
            ratingValue = judgeMeRating;
            console.log(
              "[Quick Buy] ✅ Found Judge.me rating (number):",
              ratingValue
            );
          } else if (typeof judgeMeRating === "string") {
            ratingValue = parseFloat(judgeMeRating);
            console.log(
              "[Quick Buy] ✅ Found Judge.me rating (string):",
              ratingValue
            );
          } else if (
            typeof judgeMeRating === "object" &&
            judgeMeRating.rating
          ) {
            ratingValue = parseFloat(judgeMeRating.rating);
            console.log(
              "[Quick Buy] ✅ Found Judge.me rating (object):",
              ratingValue
            );
          }
        }
      } else {
        console.log("[Quick Buy] ⚠️ product.metafields.judgeme not available");
      }

      // Priority 2: Standard reviews metafields
      if (!ratingValue) {
        console.log("[Quick Buy] Checking standard reviews metafields");
        console.log(
          "[Quick Buy] Reading metafield: product.metafields.reviews"
        );
        console.log(
          "[Quick Buy] reviews.rating:",
          product.metafields.reviews?.rating
        );
        console.log(
          "[Quick Buy] reviews.rating_count:",
          product.metafields.reviews?.rating_count
        );

        const ratingMetafield = product.metafields.reviews?.rating?.value;
        if (ratingMetafield) {
          if (typeof ratingMetafield === "object" && ratingMetafield.rating) {
            ratingValue = parseFloat(ratingMetafield.rating);
            console.log(
              "[Quick Buy] ✅ Found reviews rating (object.value):",
              ratingValue
            );
          } else if (typeof ratingMetafield === "number") {
            ratingValue = ratingMetafield;
            console.log(
              "[Quick Buy] ✅ Found reviews rating (number):",
              ratingValue
            );
          } else if (typeof ratingMetafield === "string") {
            ratingValue = parseFloat(ratingMetafield);
            console.log(
              "[Quick Buy] ✅ Found reviews rating (string):",
              ratingValue
            );
          }
        }
        if (!ratingValue && product.metafields.reviews?.rating) {
          console.log("[Quick Buy] Checking alternative reviews.rating format");
          const altRating = product.metafields.reviews.rating;
          if (typeof altRating === "object" && altRating.rating) {
            ratingValue = parseFloat(altRating.rating);
            console.log(
              "[Quick Buy] ✅ Found reviews rating (alt object):",
              ratingValue
            );
          } else if (typeof altRating === "number") {
            ratingValue = altRating;
            console.log(
              "[Quick Buy] ✅ Found reviews rating (alt number):",
              ratingValue
            );
          } else if (typeof altRating === "string") {
            ratingValue = parseFloat(altRating);
            console.log(
              "[Quick Buy] ✅ Found reviews rating (alt string):",
              ratingValue
            );
          }
        }

        if (!ratingValue) {
          console.log("[Quick Buy] ⚠️ No rating found in reviews metafields");
        }
      }
    } else {
      console.log("[Quick Buy] ⚠️ product.metafields not available");
    }

    const starSvg = `<svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.3194 1.46279L9.4926 3.82858C9.65259 4.15791 10.0792 4.4738 10.4392 4.53429L12.5656 4.8905C13.9254 5.11902 14.2454 6.11373 13.2655 7.095L11.6124 8.76181C11.3324 9.04409 11.1791 9.58849 11.2657 9.97831L11.739 12.0417C12.1123 13.6749 11.2524 14.3066 9.81924 13.4531L7.82612 12.2635C7.46616 12.0484 6.87289 12.0484 6.50627 12.2635L4.51316 13.4531C3.08665 14.3066 2.22007 13.6682 2.59337 12.0417L3.06665 9.97831C3.15331 9.58849 2.99999 9.04409 2.72002 8.76181L1.06687 7.095C0.0936431 6.11373 0.406942 5.11902 1.76679 4.8905L3.89322 4.53429C4.24652 4.4738 4.67314 4.15791 4.83312 3.82858L6.00632 1.46279C6.64625 0.179071 7.68614 0.179071 8.3194 1.46279Z" fill="#EF704D"/></svg>`;

    if (ratingValue && !isNaN(ratingValue) && ratingValue > 0) {
      if (ratingEl) {
        ratingEl.innerHTML = `
          <span class="quickbuy-rating-star">${starSvg}</span>
          <span class="quickbuy-rating-value">${ratingValue.toFixed(1)}</span>
        `;
        ratingEl.style.display = "flex";
      }
    } else {
      if (ratingEl) ratingEl.style.display = "none";
    }

    // Variant ID hidden input
    const variantInput = modal.querySelector(".quickbuy-variant-id");
    if (variantInput) variantInput.value = variant.id;

    // Compression Level - Automatic from metafields
    const compressionBox = modal.querySelector(".quickbuy-compression-box");
    if (compressionBox) {
      console.log("[Quick Buy] Checking compression level metafields");

      let compressionLevel = null;
      if (product.metafields?.custom?.compression_level_1?.value) {
        compressionLevel = product.metafields.custom.compression_level_1.value;
        console.log(
          "[Quick Buy] ✅ Found compression_level_1.value:",
          compressionLevel
        );
      } else if (product.metafields?.custom?.compression_level?.value) {
        compressionLevel = product.metafields.custom.compression_level.value;
        console.log(
          "[Quick Buy] ✅ Found compression_level.value:",
          compressionLevel
        );
      } else if (product.metafields?.custom?.compression_level_1) {
        compressionLevel = product.metafields.custom.compression_level_1;
        console.log(
          "[Quick Buy] ✅ Found compression_level_1 (direct):",
          compressionLevel
        );
      } else if (product.metafields?.custom?.compression_level) {
        compressionLevel = product.metafields.custom.compression_level;
        console.log(
          "[Quick Buy] ✅ Found compression_level (direct):",
          compressionLevel
        );
      } else {
        console.log("[Quick Buy] ⚠️ No compression level metafield found");
        console.log(
          "[Quick Buy] Available custom metafields:",
          product.metafields?.custom
            ? Object.keys(product.metafields.custom)
            : []
        );
      }

      console.log("[Quick Buy] Checking compression description metafields");

      let compressionDesc = null;
      if (product.metafields?.custom?.compression_short_description?.value) {
        compressionDesc =
          product.metafields.custom.compression_short_description.value;
        console.log(
          "[Quick Buy] ✅ Found compression_short_description.value:",
          compressionDesc
        );
      } else if (product.metafields?.custom?.compression_description?.value) {
        compressionDesc =
          product.metafields.custom.compression_description.value;
        console.log(
          "[Quick Buy] ✅ Found compression_description.value:",
          compressionDesc
        );
      } else if (product.metafields?.custom?.compression_short_description) {
        compressionDesc =
          product.metafields.custom.compression_short_description;
        console.log(
          "[Quick Buy] ✅ Found compression_short_description (direct):",
          compressionDesc
        );
      } else if (product.metafields?.custom?.compression_description) {
        compressionDesc = product.metafields.custom.compression_description;
        console.log(
          "[Quick Buy] ✅ Found compression_description (direct):",
          compressionDesc
        );
      } else {
        console.log(
          "[Quick Buy] ⚠️ No compression description metafield found"
        );
      }

      const levelEl = compressionBox.querySelector(
        ".quickbuy-compression-level"
      );
      const descEl = compressionBox.querySelector(".quickbuy-compression-desc");

      if (
        compressionLevel &&
        compressionLevel !== "" &&
        compressionLevel !== null
      ) {
        if (levelEl) {
          levelEl.textContent = compressionLevel;
        }
        const descParent = descEl ? descEl.parentElement : null;
        if (
          compressionDesc &&
          compressionDesc !== "" &&
          compressionDesc !== null
        ) {
          if (descEl) {
            descEl.textContent = compressionDesc;
          }
          if (descParent) {
            descParent.style.display = "block";
          }
        } else {
          if (descParent) {
            descParent.style.display = "none";
          }
        }
        compressionBox.style.display = "block";
      } else {
        compressionBox.style.display = "none";
      }
    }

    // Populate options
    populateOptions(product, variant);

    // View details link logic
    const viewDetailsLink = modal.querySelector(".quickbuy-view-details");
    if (viewDetailsLink) {
      // Build product URL if not available in object
      let productUrl = product.url;
      if (!productUrl && product.handle) {
        productUrl = `/products/${product.handle}`;
      } else if (!productUrl && product.id) {
        const currentPath = window.location.pathname;
        if (currentPath.includes("/products/")) {
          productUrl = currentPath.split("?")[0];
        }
      }

      viewDetailsLink.href = productUrl || "#";

      // Replace link node to remove previous handlers and reattach
      const newLink = viewDetailsLink.cloneNode(true);
      viewDetailsLink.parentNode.replaceChild(newLink, viewDetailsLink);

      newLink.addEventListener("click", (e) => {
        e.preventDefault();
        closeModal();
        setTimeout(() => {
          if (productUrl && productUrl !== "#") {
            window.location.href = productUrl;
          } else {
            console.error(
              "[Quick Buy] No valid product URL to navigate to",
              product
            );
          }
        }, 300);
      });
    }

    selectedVariant = variant;
  }

  // ---------- Populate Options ----------
  function populateOptions(product, selectedVariant) {
    if (!product || !selectedVariant) return;

    let optionsData = product.options_with_values || [];

    if (!optionsData || optionsData.length === 0) {
      const options = product.options || [];
      optionsData = options.map((optionName, index) => {
        const values = new Set();
        if (product.variants) {
          product.variants.forEach((variant) => {
            const value = variant[`option${index + 1}`];
            if (value) values.add(value);
          });
        }
        return {
          name: optionName,
          values: Array.from(values),
        };
      });
    }

    if (!Array.isArray(optionsData) || optionsData.length === 0) return;

    optionsData.forEach((option, index) => {
      if (!option) return;
      const optionName = (option.name || "").toLowerCase();
      const optionValues = option.values || [];
      if (!optionName || optionValues.length === 0) return;
      const selectedValue = selectedVariant[`option${index + 1}`];
      if (optionName.includes("color")) {
        populateColorOption(option, selectedValue, index);
      } else if (optionName.includes("size")) {
        populateSizeOption(option, selectedValue, index);
      }
    });
  }

  // ---------- Color Option ----------
  function populateColorOption(option, selectedValue, optionIndex) {
    if (!option || !option.values || !Array.isArray(option.values)) return;
    const colorContainer = modal.querySelector(".quickbuy-color-option");
    if (!colorContainer) return;

    const selectedColorSpan = colorContainer.querySelector(
      ".quickbuy-selected-color"
    );
    const swatchesContainer = colorContainer.querySelector(
      ".quickbuy-color-swatches"
    );
    if (!selectedColorSpan || !swatchesContainer) return;

    selectedColorSpan.textContent = selectedValue || "";
    swatchesContainer.innerHTML = "";

    const optionValues = option.values || [];
    const optionValuesWithData = option.values_with_data || optionValues;

    optionValues.forEach((value, valueIndex) => {
      const swatch = document.createElement("div");
      swatch.className = `quickbuy-color-swatch ${value === selectedValue ? "selected" : ""
        }`;
      swatch.setAttribute("data-value", value);
      swatch.setAttribute("data-option-index", optionIndex);
      const swatchValue = String(value).toLowerCase().replace(/"/g, "");
      swatch.setAttribute("data-swatch", swatchValue);

      // Try to get swatch color from rendered variant picker on page
      let swatchColor = null;
      const variantPicker = document.querySelector(
        ".option-selector, [data-variant-picker]"
      );
      if (variantPicker) {
        const existingSwatch = variantPicker.querySelector(
          `[data-swatch="${swatchValue}"], label[data-swatch="${swatchValue}"]`
        );
        if (existingSwatch) {
          const computedStyle = window.getComputedStyle(existingSwatch);
          const bgColor = computedStyle
            .getPropertyValue("--swatch-background-color")
            .trim();
          if (bgColor) swatchColor = bgColor;
        }
      }

      // Try product JSON values_with_data
      if (
        !swatchColor &&
        option.values_with_data &&
        option.values_with_data[valueIndex]
      ) {
        const valueData = option.values_with_data[valueIndex];
        if (
          valueData.swatch &&
          valueData.swatch.color &&
          valueData.swatch.color.rgb
        ) {
          const rgb = valueData.swatch.color.rgb;
          if (Array.isArray(rgb) && rgb.length === 3) {
            swatchColor = `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
          }
        }
      }

      if (swatchColor) {
        swatch.style.setProperty("--swatch-background-color", swatchColor);
      } else {
        const color = getColorValue(value);
        swatch.style.setProperty("--swatch-background-color", color);
      }

      swatch.addEventListener("click", () => selectOption(optionIndex, value));
      swatchesContainer.appendChild(swatch);
    });

    colorContainer.style.display = "block";
  }

  // ---------- Size Option ----------
  function populateSizeOption(option, selectedValue, optionIndex) {
    console.log("[QuickBuy] populateSizeOption() called", {
      option,
      selectedValue,
      optionIndex,
    });
    if (!option || !option.values || !Array.isArray(option.values)) {
      console.warn("[QuickBuy] Invalid option data in populateSizeOption");
      return;
    }
    const sizeContainer = modal.querySelector(".quickbuy-size-option");
    console.log("[QuickBuy] Size container found:", sizeContainer);
    if (!sizeContainer) {
      console.warn("[QuickBuy] Size container not found in modal");
      return;
    }

    const selectedSizeSpan = sizeContainer.querySelector(
      ".quickbuy-selected-size"
    );
    const buttonsContainer = sizeContainer.querySelector(
      ".quickbuy-size-buttons"
    );
    const sizeChartLink = sizeContainer.querySelector(
      ".quickbuy-size-chart-link"
    );

    if (!selectedSizeSpan || !buttonsContainer) return;

    selectedSizeSpan.textContent = selectedValue || "";
    buttonsContainer.innerHTML = "";

    option.values.forEach((value) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = `quickbuy-size-btn ${value === selectedValue ? "selected" : ""
        }`;
      button.textContent = value;
      button.setAttribute("data-value", value);
      button.setAttribute("data-option-index", optionIndex);

      const available = isVariantAvailable(optionIndex, value);
      if (!available) {
        button.disabled = true;
        button.classList.add("unavailable");
      }

      button.addEventListener("click", () => selectOption(optionIndex, value));
      buttonsContainer.appendChild(button);
    });

    sizeContainer.style.display = "block";

    // Size chart link handler - only show if size chart data exists
    console.log("[QuickBuy] Size chart link found:", sizeChartLink);
    console.log("[QuickBuy] Size chart data available:", sizeChartData);
    if (sizeChartLink) {
      // Only show size chart link if we have valid size chart data
      if (sizeChartData && sizeChartData !== null) {
        console.log("[QuickBuy] Setting up size chart link handler");
        sizeChartLink.style.display = "flex";
        sizeChartLink.href = "#";

        // Remove any existing listeners by cloning the element
        const newLink = sizeChartLink.cloneNode(true);
        sizeChartLink.parentNode.replaceChild(newLink, sizeChartLink);

        // Always attach the event listener
        newLink.addEventListener("click", (e) => {
          console.log("[QuickBuy] Size chart link clicked!");
          e.preventDefault();
          e.stopPropagation();
          console.log("[QuickBuy] Calling openSizeChartModal()");
          openSizeChartModal();
        });
        console.log("[QuickBuy] Size chart link event listener attached");
      } else {
        console.log("[QuickBuy] No size chart data available, hiding size chart link");
        sizeChartLink.style.display = "none";
      }
    } else {
      console.warn("[QuickBuy] Size chart link not found in size container");
    }
  }

  // ---------- Select option ----------
  function selectOption(optionIndex, value) {
    if (!currentProduct) return;

    const selectedOptions = {};
    for (let i = 0; i < (currentProduct.options || []).length; i++) {
      if (i === optionIndex) {
        selectedOptions[`option${i + 1}`] = value;
      } else {
        const currentValue = selectedVariant
          ? selectedVariant[`option${i + 1}`]
          : null;
        if (currentValue) selectedOptions[`option${i + 1}`] = currentValue;
      }
    }

    const variant = currentProduct.variants.find((v) => {
      let matches = true;
      for (let i = 0; i < (currentProduct.options || []).length; i++) {
        if (
          selectedOptions[`option${i + 1}`] &&
          v[`option${i + 1}`] !== selectedOptions[`option${i + 1}`]
        ) {
          matches = false;
          break;
        }
      }
      return matches;
    });

    if (variant) {
      selectedVariant = variant;
      const variantIdInput = modal.querySelector(".quickbuy-variant-id");
      if (variantIdInput) variantIdInput.value = variant.id;

      const priceEl = modal.querySelector(".quickbuy-price");
      if (priceEl) priceEl.textContent = formatPrice(variant.price);

      updateSelectedStates(optionIndex, value);
    } else {
      console.warn("No matching variant found for selection");
    }
  }

  // ---------- Update selected states ----------
  function updateSelectedStates(optionIndex, value) {
    if (!currentProduct || !currentProduct.options) return;

    let optionName = "";
    if (
      currentProduct.options_with_values &&
      currentProduct.options_with_values[optionIndex]
    ) {
      optionName = (
        currentProduct.options_with_values[optionIndex].name || ""
      ).toLowerCase();
    } else if (
      Array.isArray(currentProduct.options) &&
      currentProduct.options[optionIndex]
    ) {
      const opt = currentProduct.options[optionIndex];
      optionName = (
        typeof opt === "string" ? opt : opt.name || ""
      ).toLowerCase();
    }

    const isColorOption = optionName.includes("color");
    const isSizeOption = optionName.includes("size");

    if (isColorOption) {
      const colorSwatches = modal.querySelectorAll(".quickbuy-color-swatch");
      colorSwatches.forEach((swatch) => {
        if (swatch.getAttribute("data-option-index") == optionIndex) {
          swatch.classList.toggle(
            "selected",
            swatch.getAttribute("data-value") === value
          );
        }
      });

      const colorOption = modal.querySelector(".quickbuy-color-option");
      if (colorOption && colorOption.style.display !== "none") {
        const selectedColorSpan = colorOption.querySelector(
          ".quickbuy-selected-color"
        );
        if (selectedColorSpan) selectedColorSpan.textContent = value;
      }
    }

    if (isSizeOption) {
      const sizeButtons = modal.querySelectorAll(".quickbuy-size-btn");
      sizeButtons.forEach((btn) => {
        if (btn.getAttribute("data-option-index") == optionIndex) {
          btn.classList.toggle(
            "selected",
            btn.getAttribute("data-value") === value
          );
        }
      });

      const sizeOption = modal.querySelector(".quickbuy-size-option");
      if (sizeOption && sizeOption.style.display !== "none") {
        const selectedSizeSpan = sizeOption.querySelector(
          ".quickbuy-selected-size"
        );
        if (selectedSizeSpan) selectedSizeSpan.textContent = value;
      }
    }
  }

  // ---------- Quantity Controls ----------
  const qtyInput = modal.querySelector(".quickbuy-qty-input");
  const qtyMinus = modal.querySelector(".quickbuy-qty-minus");
  const qtyPlus = modal.querySelector(".quickbuy-qty-plus");

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener("click", () => {
      const current = parseInt(qtyInput.value) || 1;
      if (current > 1) qtyInput.value = current - 1;
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener("click", () => {
      const current = parseInt(qtyInput.value) || 1;
      qtyInput.value = current + 1;
    });
  }

  // ---------- Add to Cart ----------
  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (!selectedVariant) return;
      if (!selectedVariant.available) return;

      const addToCartBtn = form.querySelector(".quickbuy-add-to-cart");
      const originalText = addToCartBtn ? addToCartBtn.textContent : "";
      const quantity =
        parseInt(form.querySelector(".quickbuy-qty-input")?.value) || 1;

      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = "Adding...";
      }

      try {
        if (!selectedVariant.id) throw new Error("Variant ID is missing");

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: selectedVariant.id,
            quantity: quantity,
          }),
        });

        if (!response.ok) {
          const errorData = await response
            .json()
            .catch(() => ({ message: "Unknown error" }));
          throw new Error(
            errorData.description ||
            errorData.message ||
            "Failed to add to cart"
          );
        }

        const data = await response.json();

        // Dispatch cart update events
        document.dispatchEvent(
          new CustomEvent("on:cart:change", {
            bubbles: true,
            cancelable: false,
          })
        );
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true })
        );

        // Try updating page header section if present
        const pageHeader = document.querySelector("page-header");
        if (pageHeader && pageHeader.dataset.sectionId) {
          fetch(
            `${window.Shopify.routes.root}?section_id=${pageHeader.dataset.sectionId}`
          )
            .then((resp) => resp.text())
            .then((html) => {
              if (pageHeader.updateFromCartChange)
                pageHeader.updateFromCartChange(html);
            })
            .catch((err) => console.error("Error updating page header:", err));
        }

        // Close modal after short delay
        setTimeout(() => closeModal(), 300);
      } catch (error) {
        console.error("Error adding to cart:", error);
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = originalText || "Add to Cart";
        }
      }
    });
  }

  // ---------- Close Modal ----------
  function closeModal() {
    modal.classList.remove("active");
    modal.classList.add("hidden");
    if (content) content.style.display = "none";
    if (loader) loader.style.display = "none";
    currentProduct = null;
    selectedVariant = null;
    quickBuySource = null; // Reset source when closing modal
    if (form) form.reset();

    const addToCartBtn = form?.querySelector(".quickbuy-add-to-cart");
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Add to Cart";
    }
  }

  [overlay, closeBtn].forEach((el) => {
    if (el) el.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      closeModal();
    }
  });

  // ---------- Helpers ----------
  function formatPrice(price) {
    try {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
      }).format(price / 100);
    } catch (e) {
      return price;
    }
  }

  function getColorValue(colorName) {
    const colorMap = {
      ivory: "#FFFFF0",
      beige: "#F5F5DC",
      nude: "#E3BC9A",
      black: "#000000",
      white: "#FFFFFF",
      brown: "#A52A2A",
      "petal pink": "#FFC0CB", /* Added Petal Pink */
      "petal": "#FFC0CB",
      pink: "#FFC0CB",
    };
    return colorMap[String(colorName || "").toLowerCase()] || "#CCCCCC";
  }

  function isVariantAvailable(optionIndex, value) {
    if (!currentProduct) return false;

    // Create a map of currently selected options
    const currentOptions = {};
    if (selectedVariant) {
      for (let i = 0; i < currentProduct.options.length; i++) {
        currentOptions[`option${i + 1}`] = selectedVariant[`option${i + 1}`];
      }
    }

    // Override the option we are checking
    currentOptions[`option${optionIndex + 1}`] = value;

    // Find the variant that matches ALL options
    const matchingVariant = currentProduct.variants.find((v) => {
      let match = true;
      for (let i = 0; i < currentProduct.options.length; i++) {
        const key = `option${i + 1}`;
        if (v[key] !== currentOptions[key]) {
          match = false;
          break;
        }
      }
      return match;
    });

    return matchingVariant ? matchingVariant.available : false;
  }

  // ---------- Size Chart: creation, extraction, population ----------

  // Create Size Chart Modal
  function createSizeChartModal() {
    console.log("[QuickBuy] createSizeChartModal() called");
    if (document.getElementById("quickbuy-size-chart-modal")) {
      console.log("[QuickBuy] Size chart modal already exists");
      return;
    }

    console.log("[QuickBuy] Creating size chart modal element");
    const sizeChartModal = document.createElement("div");
    sizeChartModal.id = "quickbuy-size-chart-modal";
    sizeChartModal.className = "hidden";
    sizeChartModal.innerHTML = `
      <div class="quickbuy-size-chart-overlay"></div>
      <div class="quickbuy-size-chart-container">
        <button class="quickbuy-size-chart-close" aria-label="Close size chart">×</button>
        <div class="quickbuy-size-chart-content"></div>
      </div>
    `;
    document.body.appendChild(sizeChartModal);
    console.log("[QuickBuy] Size chart modal appended to body");

    const closeBtn = sizeChartModal.querySelector(".quickbuy-size-chart-close");
    const overlay = sizeChartModal.querySelector(
      ".quickbuy-size-chart-overlay"
    );
    if (closeBtn) closeBtn.addEventListener("click", closeSizeChartModal);
    if (overlay) overlay.addEventListener("click", closeSizeChartModal);

    // Close on Escape when modal active
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && sizeChartModal.classList.contains("active")) {
        closeSizeChartModal();
      }
    });

    // Observe attribute changes to re-setup drag-to-scroll when opened
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (sizeChartModal.classList.contains("active")) {
            setTimeout(setupDragToScroll, 100);
          }
        }
      });
    });
    observer.observe(sizeChartModal, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Check accessory heuristics
  function isAccessoryProduct(product, url) {
    if (!product) return false;
    if (url) {
      const urlLower = url.toLowerCase();
      if (
        urlLower.includes("accessories") ||
        urlLower.includes("/accessories/")
      )
        return true;
      const handleMatch = url.match(/\/products\/([^\/\?#]+)/);
      if (handleMatch && handleMatch[1]) {
        const handle = handleMatch[1].toLowerCase();
        if (
          handle.includes("nipple") ||
          handle.includes("tape") ||
          handle.includes("cover") ||
          handle.includes("accessory")
        )
          return true;
      }
    }

    const titleLower = String(product.title || "").toLowerCase();
    if (
      titleLower.includes("tape") ||
      titleLower.includes("nipple") ||
      titleLower.includes("cover") ||
      titleLower.includes("breast lift") ||
      titleLower.includes("bunny ups") ||
      titleLower.includes("accessory")
    )
      return true;

    const typeLower = String(product.product_type || "").toLowerCase();
    if (typeLower.includes("accessory") || typeLower.includes("accessories"))
      return true;

    if (product.tags && Array.isArray(product.tags)) {
      const hasAccessoryTag = product.tags.some((tag) =>
        String(tag || "")
          .toLowerCase()
          .includes("accessory")
      );
      if (hasAccessoryTag) return true;
    }

    if (product.handle) {
      const handleLower = String(product.handle).toLowerCase();
      if (
        handleLower.includes("nipple") ||
        handleLower.includes("tape") ||
        handleLower.includes("cover") ||
        handleLower.includes("accessory")
      )
        return true;
    }

    return false;
  }

  // Extract size chart data from fetched product page
  function extractSizeChartData(doc, product, url) {
    if (!doc) {
      sizeChartData = null;
      return;
    }

    const isAccessory = isAccessoryProduct(product, url);

    // PRIORITY 1: Quick Buy specific size chart snippet (uses unique IDs)
    const quickBuyModal = doc.querySelector('#quickbuy-size-chart-modal-content');
    if (quickBuyModal) {
      const contentEl = quickBuyModal.querySelector('.size-chart-content');
      // We want the whole modal structure because it contains the scoped close button and overlay
      const html = quickBuyModal.outerHTML;

      let style = '';
      const styleTags = Array.from(doc.querySelectorAll('style'));
      styleTags.forEach((tag) => {
        const t = tag.textContent || '';
        if (t.includes('.size-chart-') || t.includes('size-chart-')) {
          style += t + '\n';
        }
      });

      // Extract the script associated with the modal
      let script = '';
      const scriptTags = Array.from(doc.querySelectorAll('script'));
      scriptTags.forEach((tag) => {
        const t = tag.textContent || '';
        if (t.includes('openCustomSizeChartQuickBuy')) {
          script = t;
        }
      });

      sizeChartData = { type: 'custom-quickbuy', html, style, script };
      console.log('[Quick Buy] ✅ Using dedicated Quick Buy size chart snippet');
      return;
    }

    // PRIORITY 2: Custom size chart snippet modal (fallback if dedicated not found)
    const customModal = doc.querySelector('#custom-product-size-chart-modal');
    if (customModal) {
      const contentEl = customModal.querySelector('.size-chart-content');
      const html = contentEl ? contentEl.innerHTML : customModal.innerHTML;
      let style = '';
      const styleTags = Array.from(doc.querySelectorAll('style'));
      styleTags.forEach((tag) => {
        const t = tag.textContent || '';
        if (t.includes('.size-chart-') || t.includes('size-chart-')) {
          style += t + '\n';
        }
      });

      // Extract the script associated with the modal
      let script = '';
      const scriptTags = Array.from(doc.querySelectorAll('script'));
      scriptTags.forEach((tag) => {
        const t = tag.textContent || '';
        if (t.includes('openCustomSizeChart')) {
          script = t;
        }
      });

      sizeChartData = { type: 'custom', html, style, script };
      console.log('[Quick Buy] ✅ Using custom size chart from metafield (with script)');
      return;
    }

    // If accessory and no custom modal found -> no size chart
    if (isAccessory) {
      sizeChartData = null;
      console.log('[Quick Buy] ⚠️ Accessory product with no custom size chart');
      return;
    }

    // No custom size chart found and not an accessory -> no size chart
    // We no longer fall back to Mageplaza modals or page-based size charts
    console.log('[Quick Buy] ⚠️ No custom size chart found for this product');
    sizeChartData = null;
  }

  // Fetch size chart page content (returns inner HTML or null)
  async function fetchSizeChartPage(pageHandle) {
    try {
      const url = `/pages/${pageHandle}`;
      const response = await fetch(url);
      if (!response.ok) return null;
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const pageContent = doc.querySelector(".rte, .page-content, main");
      if (pageContent) return pageContent.innerHTML;
      return doc.body.innerHTML;
    } catch (error) {
      return null;
    }
  }

  // Populate size chart modal with dynamic data
  async function populateSizeChartModal() {
    console.log("[QuickBuy] populateSizeChartModal() called");
    console.log("[QuickBuy] sizeChartData:", sizeChartData);

    // For the dedicated Quick Buy snippet, we handle it differently
    if (sizeChartData?.type === 'custom-quickbuy') {
      console.log('[QuickBuy] Using dedicated Quick Buy size chart snippet');

      // Remove any existing Quick Buy size chart modal
      const existingModal = document.getElementById('quickbuy-size-chart-modal-content');
      if (existingModal) {
        existingModal.remove();
        console.log('[QuickBuy] Removed existing Quick Buy size chart modal');
      }

      // Create a container and inject the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sizeChartData.html;

      // Append the modal to body
      const modal = tempDiv.querySelector('#quickbuy-size-chart-modal-content');
      if (modal) {
        document.body.appendChild(modal);
        console.log('[QuickBuy] Appended Quick Buy size chart modal to body');
      }

      // Inject and execute the script
      if (sizeChartData.script) {
        console.log('[QuickBuy] Executing Quick Buy size chart script');
        let scriptContent = sizeChartData.script;
        scriptContent = scriptContent.replace(/<script>/g, '').replace(/<\/script>/g, '');

        try {
          const scriptEl = document.createElement('script');
          scriptEl.textContent = scriptContent;
          document.body.appendChild(scriptEl);
          console.log('[QuickBuy] Quick Buy size chart script executed successfully');
        } catch (e) {
          console.error('[QuickBuy] Error executing Quick Buy size chart script:', e);
        }
      }

      return;
    }

    // For fallback custom snippet, use the old modal container approach
    const sizeChartModal = document.getElementById("quickbuy-size-chart-modal");
    if (!sizeChartModal) {
      console.error(
        "[QuickBuy] Size chart modal not found in populateSizeChartModal"
      );
      return;
    }
    const contentContainer = sizeChartModal.querySelector(
      ".quickbuy-size-chart-content"
    );
    if (!contentContainer) {
      console.error("[QuickBuy] Size chart content container not found");
      return;
    }
    console.log("[QuickBuy] Content container found, populating...");

    // No hardcoded content - removed

    // HTML content captured from product page
    if (sizeChartData?.type === "html") {
      if (sizeChartData.content && sizeChartData.content.trim().length > 0) {
        contentContainer.innerHTML = `<h2 class="quickbuy-size-chart-title">Size Chart</h2><div class="quickbuy-size-chart-dynamic-content">${sizeChartData.content}</div>`;
        return;
      }
    }

    // Custom snippet content captured from product page
    if (sizeChartData?.type === 'custom') {
      const productId = currentProduct ? currentProduct.id : '';

      let html = '';
      // Fallback for old snippet
      html = buildQuickBuyMarkupFromCustom(
        sizeChartData.html || '',
        sizeChartData.style || '',
        productId
      );

      contentContainer.innerHTML = html;

      // Inject and execute the script
      if (sizeChartData.script) {
        console.log('[QuickBuy] Injecting size chart script');
        let scriptContent = sizeChartData.script;

        // ... (keep existing patching logic for fallback) ...
        // 1. Rename the function to avoid conflict
        scriptContent = scriptContent.replace(
          /window\.openCustomSizeChart/g,
          'window.openCustomSizeChartQuickBuy'
        );

        // 2. Target the Quick Buy modal instead of the custom modal
        scriptContent = scriptContent.replace(
          /custom-product-size-chart-modal/g,
          'quickbuy-size-chart-modal'
        );

        // 3. Update productId to match the renamed IDs (appended with -quickbuy)
        if (productId) {
          const pidRegex = new RegExp(`const productId = "${productId}";`);
          scriptContent = scriptContent.replace(
            pidRegex,
            `const productId = "${productId}-quickbuy";`
          );
        }

        // Remove script tags
        scriptContent = scriptContent.replace(/<script>/g, '').replace(/<\/script>/g, '');

        // Execute
        try {
          const scriptEl = document.createElement('script');
          scriptEl.textContent = scriptContent;
          document.body.appendChild(scriptEl);
          console.log('[QuickBuy] Custom script executed successfully');
        } catch (e) {
          console.error('[QuickBuy] Error executing custom script:', e);
        }
      }
      return;
    }

    // Fetch page handle content
    if (sizeChartData?.type === "page") {
      const pageContent = await fetchSizeChartPage(sizeChartData.pageHandle);
      if (pageContent && pageContent.trim().length > 0) {
        contentContainer.innerHTML = `<h2 class="quickbuy-size-chart-title">Size Chart</h2><div class="quickbuy-size-chart-dynamic-content">${pageContent}</div>`;
        return;
      }
    }

    // Metafield content
    if (sizeChartData?.type === "metafield") {
      if (sizeChartData.content && sizeChartData.content.trim().length > 0) {
        contentContainer.innerHTML = `<h2 class="quickbuy-size-chart-title">Size Chart</h2><div class="quickbuy-size-chart-dynamic-content">${sizeChartData.content}</div>`;
        return;
      }
    }

    // No fallback - only show size chart if metafield exists
    contentContainer.innerHTML = `<div class="quickbuy-size-chart-empty"><p>Size chart not available for this product.</p></div>`;
  }

  // Helper to build asset URL
  function getAssetUrl(filename) {
    if (
      typeof Shopify !== "undefined" &&
      Shopify.routes &&
      Shopify.routes.root
    ) {
      return Shopify.routes.root + "assets/" + filename;
    }
    return "/assets/" + filename;
  }

  // Removed hardcoded accessories size chart content

  // Removed hardcoded default size chart content

  // Open size chart modal
  async function openSizeChartModal() {
    console.log("[QuickBuy] openSizeChartModal() called");

    // Simply call the custom size chart open function
    // The modal and all its logic is rendered via custom-size-chart-modal.liquid
    if (window.openCustomSizeChartQuickBuy) {
      console.log("[QuickBuy] Calling openCustomSizeChartQuickBuy (patched)");
      window.openCustomSizeChartQuickBuy();
    } else if (window.openCustomSizeChart) {
      console.log("[QuickBuy] Calling openCustomSizeChart (fallback)");
      window.openCustomSizeChart();
    } else {
      console.error("[QuickBuy] openCustomSizeChart function not found");
    }
  }

  function closeSizeChartModal() {
    // Close custom size chart page first
    const sizeChartPage = document.getElementById("quickbuy-size-chart-page");
    if (sizeChartPage && sizeChartPage.classList.contains("active")) {
      sizeChartPage.classList.remove("active");
      sizeChartPage.classList.add("hidden");
      document.body.style.overflow = "";
      return;
    }

    // Fallback to dynamic modal
    const sizeChartModal = document.getElementById("quickbuy-size-chart-modal");
    if (!sizeChartModal) return;
    sizeChartModal.classList.remove("active");
    sizeChartModal.classList.add("hidden");
    document.body.style.overflow = "";
  }

  // Update size chart units
  function updateSizeChartUnits(unit) {
    const sizeM = document.getElementById("size-m-value");
    const sizeL = document.getElementById("size-l-value");
    if (!sizeM || !sizeL) return;
    if (unit === "inches") {
      sizeM.textContent = "3.0";
      sizeL.textContent = "4.0";
    } else {
      sizeM.textContent = "7.7";
      sizeL.textContent = "10.2";
    }
  }

  // Setup drag to scroll for size chart table wrapper
  function setupDragToScroll() {
    const tableWrapper = document.querySelector(
      ".quickbuy-size-chart-table-wrapper"
    );
    if (!tableWrapper) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // remove previous listeners if any by cloning wrapper (safe)
    const newWrapper = tableWrapper.cloneNode(true);
    tableWrapper.parentNode.replaceChild(newWrapper, tableWrapper);

    newWrapper.addEventListener("mousedown", (e) => {
      isDown = true;
      newWrapper.style.cursor = "grabbing";
      newWrapper.style.userSelect = "none";
      startX = e.pageX - newWrapper.offsetLeft;
      scrollLeft = newWrapper.scrollLeft;
    });

    newWrapper.addEventListener("mouseleave", () => {
      isDown = false;
      newWrapper.style.cursor = "grab";
      newWrapper.style.userSelect = "";
    });

    newWrapper.addEventListener("mouseup", () => {
      isDown = false;
      newWrapper.style.cursor = "grab";
      newWrapper.style.userSelect = "";
    });

    newWrapper.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - newWrapper.offsetLeft;
      const walk = (x - startX) * 2;
      newWrapper.scrollLeft = scrollLeft - walk;
    });

    newWrapper.style.cursor = "grab";
  }

  // Update size chart units for static page (with data attributes)
  function updateSizeChartUnitsPage(unit) {
    // Update measurement cells
    const measurementCells = document.querySelectorAll(
      "#quickbuy-size-chart-page .measurement-cell"
    );
    measurementCells.forEach((cell) => {
      const inchesValue = cell.getAttribute("data-inches");
      const cmValue = cell.getAttribute("data-cm");
      if (unit === "inches" && inchesValue) {
        cell.textContent = inchesValue;
      } else if (unit === "cm" && cmValue) {
        cell.textContent = cmValue;
      }
    });

    // Update measurement unit headers
    const unitHeaders = document.querySelectorAll(
      "#quickbuy-size-chart-page .measurement-unit"
    );
    unitHeaders.forEach((header) => {
      const inchesLabel = header.getAttribute("data-unit-inches");
      const cmLabel = header.getAttribute("data-unit-cm");
      if (unit === "inches" && inchesLabel) {
        header.textContent = inchesLabel;
      } else if (unit === "cm" && cmLabel) {
        header.textContent = cmLabel;
      }
    });
  }

  // Setup tips background image for static page
  function setupSizeChartPageTips() {
    const tipsSection = document.querySelector(
      "#quickbuy-size-chart-page .quickbuy-size-chart-tips"
    );
    if (tipsSection) {
      const isDesktop = window.innerWidth >= 768;
      const bgUrl = getAssetUrl(
        isDesktop ? "Tips_Card_big.svg" : "Tips_Card.svg"
      );
      tipsSection.style.backgroundImage = `url('${bgUrl}')`;
      tipsSection.style.backgroundRepeat = "no-repeat";
      tipsSection.style.backgroundPosition = "center center";
      tipsSection.style.backgroundSize = "cover";
    }
  }

  // ---------- Initialize size chart page close handlers (for content-driven close elements) ----------
  (function initSizeChartPage() {
    const sizeChartPage = document.getElementById("quickbuy-size-chart-page");
    if (!sizeChartPage) return;

    const overlay = sizeChartPage.querySelector(".quickbuy-size-chart-overlay");
    const closeBtn = sizeChartPage.querySelector(".quickbuy-size-chart-close");
    if (overlay) overlay.addEventListener("click", closeSizeChartModal);
    if (closeBtn) closeBtn.addEventListener("click", closeSizeChartModal);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && sizeChartPage.classList.contains("active")) {
        closeSizeChartModal();
      }
    });

    // Setup unit change listeners for static page
    const toggleBtns = sizeChartPage.querySelectorAll(
      '.quickbuy-size-chart-toggle-btn'
    );
    if (toggleBtns.length > 0) {
      toggleBtns.forEach((btn) => {
        btn.addEventListener("click", function () {
          const unit = this.getAttribute("data-unit");

          // Update active state
          toggleBtns.forEach(b => b.classList.remove("active"));
          this.classList.add("active");

          updateSizeChartUnitsPage(unit);
        });
      });
      // Initialize with default (inches)
      updateSizeChartUnitsPage("inches");
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          if (sizeChartPage.classList.contains("active")) {
            setTimeout(() => {
              setupDragToScroll();
              setupSizeChartPageTips();
            }, 100);
          }
        }
      });
    });
    observer.observe(sizeChartPage, {
      attributes: true,
      attributeFilter: ["class"],
    });
  })();
});
function mapSizeChartClasses(str) {
  const pairs = [
    ['size-chart-title', 'quickbuy-size-chart-title'],
    ['size-chart-unit', 'quickbuy-size-chart-unit'],
    ['size-chart-unit-toggle', 'quickbuy-size-chart-unit-toggle'],
    ['size-chart-toggle-btn', 'quickbuy-size-chart-toggle-btn'],
    ['size-chart-unit-label', 'quickbuy-size-chart-unit-label'],
    ['size-chart-radio-group', 'quickbuy-size-chart-radio-group'],
    ['size-chart-radio', 'quickbuy-size-chart-radio'],
    ['size-chart-table-wrapper', 'quickbuy-size-chart-table-wrapper'],
    ['size-chart-table', 'quickbuy-size-chart-table'],
    ['size-chart-section-title', 'quickbuy-size-chart-section-title'],
    ['size-chart-measure-visual', 'quickbuy-size-chart-measure-visual'],
    ['size-chart-measure-image', 'quickbuy-size-chart-measure-image'],
    ['size-chart-image-desktop', 'quickbuy-size-chart-image-desktop'],
    ['size-chart-image-mobile', 'quickbuy-size-chart-image-mobile'],
    ['size-chart-tips', 'quickbuy-size-chart-tips'],
    ['size-chart-tips-title', 'quickbuy-size-chart-tips-title'],
    ['size-chart-tips-icon', 'quickbuy-size-chart-tips-icon'],
    ['size-chart-tips-list', 'quickbuy-size-chart-tips-list']
  ];
  let out = str;
  pairs.forEach(([from, to]) => {
    const re = new RegExp(from, 'g');
    out = out.replace(re, to);
  });
  // Normalize product-scoped IDs
  out = out.replace(/size-chart-data-inches-[0-9]+/g, 'size-chart-data-inches');
  out = out.replace(/size-chart-data-cm-[0-9]+/g, 'size-chart-data-cm');
  out = out.replace(/name="size-chart-unit-[0-9]+"/g, 'name="size-chart-unit"');
  out = out.replace(/id="size-chart-inches-[0-9]+"/g, 'id="size-chart-inches"');
  out = out.replace(/id="size-chart-cm-[0-9]+"/g, 'id="size-chart-cm"');
  out = out.replace(/for="size-chart-inches-[0-9]+"/g, 'for="size-chart-inches"');
  out = out.replace(/for="size-chart-cm-[0-9]+"/g, 'for="size-chart-cm"');
  return out;
}

function buildQuickBuyMarkupFromCustom(html, style, productId) {
  // Do NOT use mapSizeChartClasses as it strips IDs needed by the script
  // and the custom modal has its own scoped styles.
  let mappedHtml = html;

  // 1. Replace the root modal ID
  mappedHtml = mappedHtml.replace(
    /id="custom-product-size-chart-modal"/g,
    'id="quickbuy-size-chart-modal"'
  );

  // 2. Append -quickbuy to product ID occurrences (IDs and data attributes)
  if (productId) {
    const pidRegex = new RegExp(productId, 'g');
    mappedHtml = mappedHtml.replace(pidRegex, `${productId}-quickbuy`);
  }

  // 3. Ensure we didn't break the root ID replacement if productId was part of it (unlikely for root)

  const styleTag = style
    ? `<style data-qb-custom-size-chart>${style}</style>`
    : '';
  return `${styleTag}${mappedHtml}`;
}
